module.exports = __webpack_public_path__ + "static/media/photo48.f0b81b53.jpg";